const isPro = process.env.NODE_ENV === 'production';
module.exports = {
    ip: isPro ? '' : '192.168.254.100', //第二个参数是测试环境 192.168.254.100
    sharedstore:['access_token','refresh_token','expires_in','expires_in_store_time','userInfo', 'companyId'],//公共localstore
}